import { render, staticRenderFns } from "./Stay.vue?vue&type=template&id=38520449&scoped=true"
import script from "./Stay.vue?vue&type=script&lang=js"
export * from "./Stay.vue?vue&type=script&lang=js"
import style0 from "./Stay.vue?vue&type=style&index=0&id=38520449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38520449",
  null
  
)

export default component.exports